// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1fbbb2d0","952":"e590bbd7"}[chunkId] + ".chunk.js";
};